var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.methodsProvider,{tag:"component",on:{"error":_vm.onError},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var loading = ref.loading;
var deleting = ref.deleting;
var paymentMethods = ref.paymentMethods;
var deletePaymentMethod = ref.deletePaymentMethod;
return [_c('PaymentMethodsTable',{attrs:{"is-loading":loading,"is-deleting":deleting,"payment-methods":paymentMethods},on:{"delete":deletePaymentMethod}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }